var DKMS = window.DKMS || {};

DKMS.Contact = (function () {
    var f = function () {

        $('#id_drive_date, #id_party_date').on('change', function () {
            var val = $(this).val(), wrapper = $('section.personalinfo');
            wrapper.toggleClass('show-drive-date', val === 'yes');
        });
    };
    return f;
})();

new DKMS.Contact;
